import {Component, Inject, ViewChild, ComponentFactoryResolver, ViewContainerRef, ComponentRef} from '@angular/core';
import {MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { PopupService } from '../popupmessage.service';
import { DynamicDialogService } from './dynamicdialog.service';

@Component({
    selector: 'dialog-comp',
    templateUrl: './dynamicdialog.component.html',
})
export class DynamicDialog {
    @ViewChild('target', { read: ViewContainerRef, static: true }) vcRef: ViewContainerRef | undefined;

    public componentRef: ComponentRef<any> | undefined;
    public scroller: Element | null | undefined;
    public navToTop:boolean = false;
    public templateContentClass = "dynamic-dialog-template-content"
    public dialogContentClass = "dynamic-dialog"
    public containerId:string = "";


    constructor(
        public dialogRef: MatDialogRef<DynamicDialog>,
        private resolver: ComponentFactoryResolver,
        private dialogSrv:DynamicDialogService,
        private popupSrv:PopupService,
        @Inject(MAT_DIALOG_DATA) public data: {component:any, input:any, fullScreen:boolean}) {
    };

    ngOnInit() {
        console.log(this.data)
        this.containerId = this.dialogSrv.getcontainerId();
        if(this.data.fullScreen){
            this.templateContentClass = "dynamic-dialog-template-content-full"
            this.dialogContentClass = "dynamic-dialog-full"
        }
        const factory = this.resolver.resolveComponentFactory(this.data.component);
        if(typeof this.vcRef != 'undefined'){
            this.componentRef = this.vcRef.createComponent(factory);
            this.componentRef.instance.item = this.data.input;
            this.componentRef.instance.clickAction.subscribe((val: any)=>{
                console.log(val);
                this.dialogRef.close(val);
            })
        }
        this.dialogSrv.setDirtyFlag(this.data.component.name,false);
        
        setTimeout(()=>{
            this.scroller = document.querySelector("#"+this.containerId);
            if(this.scroller != null && typeof this.scroller != "undefined"){
                this.scroller.addEventListener("scroll",event=>{
                    if(this.scroller != null && typeof this.scroller != "undefined"){
                        this.navToTop = (this.scroller.scrollTop > 10)
                    }
                })
            }
        },0)
        
    };

    ngOnDestroy() {
        this.dialogSrv.discardFormStatus(this.data.component.name);
        if (this.componentRef) {
            this.componentRef.destroy();
        }
        // this.scroller.
    };

    public closeDialog(){
        if(this.dialogSrv.isDirty(this.data.component.name)){
            this.popupSrv.confirm("Unsaved Data Detected","Are you sure you want to discard your changes?","Confirm Discarding Changes",2).subscribe((result)=>{
                if(result===true){
                    this.dialogRef.close({data:'',clickAction:'close'})
                }
            })
        }else{
            this.dialogRef.close({data:'',clickAction:'close'})
        }
    }

    scrollToTop(){
        let ele = document.getElementById(this.containerId);
        if(ele != null){
            ele.scrollTop = 0;
        }
    }
}